export default "__VITE_ASSET__BiHYbT02__"